<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :style="svgStyle"
    :viewBox="viewBox"
  >

    <path
      d="M23.3,12.49a4.2,4.2,0,0,0-3.56-4.14V4.93a1.16,1.16,0,0,0-1.16-1.16,1,1,0,0,0-.48.1L7.63,8.5H4.56A4.23,4.23,0,0,0,.29,12.67a4.18,4.18,0,0,0,2.94,3.94l1.92,7.2a1.17,1.17,0,0,0,1.13.87H9.84a1.16,1.16,0,0,0,.92-.46,1.19,1.19,0,0,0,.21-1L9.47,17.6l8.66,3.52a1.12,1.12,0,0,0,.44.09A1.19,1.19,0,0,0,19.74,20V16.63A4.21,4.21,0,0,0,23.3,12.49Zm-21.19.18a2.39,2.39,0,0,1,2.4-2.4H7.87v4.8H4.57a2.4,2.4,0,0,1-2.46-2.34ZM9.28,22.81H6.48L5,17.49h2.8Zm.6-7.44V9.88l7.7-3.44v12Zm12.28-2.88a3.09,3.09,0,0,1-2.42,3v-6A3.06,3.06,0,0,1,22.16,12.49Z"
      :style="`fill:${fill}`"
    />
    <path
      d="M27.56,11.81h-2.8a.6.6,0,0,0,0,1.2h2.8a.6.6,0,1,0,0-1.2Z"
      :style="`fill:${fill}`"
    />
    <path
      d="M21.51,8.39a.63.63,0,0,0,.5-.25l2-2.86a.61.61,0,0,0-.16-.85.6.6,0,0,0-.84.16L21,7.45a.61.61,0,0,0,.15.84A.56.56,0,0,0,21.51,8.39Z"
      :style="`fill:${fill}`"
    />
    <path
      d="M25.23,15.61l-1.43-.84A.59.59,0,0,0,23,15a.59.59,0,0,0,.21.82l1.43.83a.61.61,0,0,0,.82-.21.6.6,0,0,0-.22-.82Z"
      :style="`fill:${fill}`"
    />
    <path
      d="M22,17a.61.61,0,0,0-.84-.15.6.6,0,0,0-.15.83l2,2.86a.61.61,0,0,0,.5.26.6.6,0,0,0,.49-.94Z"
      :style="`fill:${fill}`"
    />
    <path
      d="M23,10.13a.58.58,0,0,0,.52.3.54.54,0,0,0,.3-.08l1.44-.83a.61.61,0,0,0,.21-.82.59.59,0,0,0-.81-.21h0l-1.44.82A.6.6,0,0,0,23,10.13Z"
      :style="`fill:${fill}`"
    />
  </svg>
</template>
<script>
export default {
  props: {
    viewBox: { type: String, default: '0 0 28.44 28.44' },
    fill: { type: String, default: '#FFFFFF' },
    svgClass: { type: String },
    svgStyle: { type: Object },
  },
};
</script>
